import React, { useContext, useMemo } from "react";
import { Button, buttonClasses, SxProps, Theme } from "@mui/material";
import { ChevronDown } from "react-feather";
import { DropdownContext } from ".";

/**
 * @typedef {Object} CustomDropdownProps
 * @property {React.ReactNode} children
 * @property {React.ReactNode} ParentComponent
 * @property {SxProps<Theme>} sx
 */

/**
 * @param {CustomDropdownProps} param0
 * @returns {JSX.Element} Dropdown component
 */
const DropdownBtn = ({ children, ParentComponent, ...props }) => {
  const { open, handleClick } = useContext(DropdownContext);

  const Wrapper = useMemo(
    () =>
      ({ children }) =>
        ParentComponent ? (
          <ParentComponent>{children}</ParentComponent>
        ) : (
          children
        ),
    [ParentComponent]
  );

  return (
    <Wrapper>
      <Button
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        endIcon={<ChevronDown size={12} strokeWidth={4} />}
        {...props}
        onClick={(e) => {
          props?.onClick?.(e);
          handleClick(e);
        }}
        sx={{
          minWidth: 0,
          padding: 0,
          color: "#438593",
          height: "16px",
          cursor: "pointer",
          [`& .${buttonClasses.endIcon}`]: {
            margin: 0,
          },
          ...props?.sx,
        }}
      >
        {children}
      </Button>
    </Wrapper>
  );
};

export default DropdownBtn;
